<template>
    <nav>
      <vue-paginate
        v-model="page"
        container-class="pagination justify-content-center"
        :page-count="totalPage"
        prev-text="«"
        next-text="»"
        page-class="page-item"
        page-link-class="page-link"
        prev-link-class="page-link"
        next-link-class="page-link"
        :click-handler="callback"
      ></vue-paginate>
    </nav>
</template>
  
<script>
  export default {
    name: 'ContactPaginate',
    props: {
      totalPage: {
        type: Number,
        required: true
      },
      callback: {
        type: Function,
        required: true
      },
      currentPage: {
        type: Number,
        required: true,
        default: 1
      }
    },
    data() {
      return {
        page: 1,
      };
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(value) {
          this.page = value;
        }
      },
    },
    mounted() {
      this.page = this.currentPage;
    },
  };
  </script>
  
  <style scoped>
  </style>
  
